<app-cart-template
  *ngIf="cartProducts.length && currentStep !== cartStep.CONFIRMATION"
  [currentStep]="currentStep"
  [isLoading]="isLoading"
  (nextClicked)="onNextClick()"
  (backClicked)="onBackClick()"
  (cancelClicked)="onCancelClick()"
>
  <app-cart-products
    *ngIf="currentStep === cartStep.PRODUCTS"
    [cartProducts]="cartProducts"
    (productClicked)="onCartProductClick($event)"
    (trashClicked)="onTrashClicked($event)"
  ></app-cart-products>

  <app-cart-details #cartDetails *ngIf="currentStep === cartStep.DETAILS"></app-cart-details>

  <app-cart-summary
    *ngIf="currentStep === cartStep.SUMMARY"
    [name]="cartDetailsValues.name"
    [email]="cartDetailsValues.email"
    [address]="cartDetailsValues.address"
    [totalItems]="getTotalItems()"
    [totalPrice]="getTotalPrice()"
  ></app-cart-summary>
</app-cart-template>

<app-state-message
  *ngIf="currentStep === cartStep.CONFIRMATION"
  [imgUrl]="confirmationImageUrl"
  [title]="'We got your order!'"
  [subtitle]="'One of our agents will contact you within 2 business days'"
></app-state-message>

<app-state-message
  *ngIf="!cartProducts.length"
  [title]="'Cart is empty'"
  [subtitle]="'Keep looking for the best outfits in our site'"
></app-state-message>

<app-snackbar [snackbarLabel$]="snackbarLabelSubject$"></app-snackbar>
